import React from 'react';
import { Form } from 'react-bootstrap';
import { FormTextBox } from '../components/FormTextBox';

/**Controlled form which handles the company details */
export const CompanyForm = (props) => {

    const onChange = (ev, input) => {
        const company = ev.target.value;
        props.setCompany(company);
    };

    return <Form>
            <FormTextBox formLabel="Company" textChanger={onChange} value={props.company || ""}
                name="company" placeholder="Company Name" readOnly={false} />
        </Form>
};


// WEBPACK FOOTER //
// ./src/components/adminCenter/CompanyForm.js